import type { ParsedQuestion } from '../../components/survey/types';

/** Types whose every renderer submits the answer from the click that picks it. */
export const CLICK_TO_ADVANCE_TYPES: readonly string[] = [
  'single_choice',
  'yes_no',
  'rating_scale',
  'likert_scale',
  'dropdown',
  'nps',
];

export interface NextButtonContext {
  hasFollowup: boolean;
}

/**
 * `required` plays no part: canProceed refuses Next on an empty answer for every question, so an
 * optional click-to-advance question cannot use Next either.
 */
export function isNextButtonRedundant(
  question: Pick<ParsedQuestion, 'type' | 'allow_other'>,
  ctx: NextButtonContext,
): boolean {
  return (
    CLICK_TO_ADVANCE_TYPES.includes(question.type) && !question.allow_other && !ctx.hasFollowup
  );
}
